import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAuth } from "../../../../../store/auth_slice";
import Button from "../../../../../common/button/button";
import InformationModal from "../../../../../common/modal/information_modal";

const TextSection: React.FC = () => {
  const [isInfoModalOpen, setIsInfoModalOpen] = React.useState(false);
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector(selectAuth);

  const handleStripeSetup = () => {
    setIsInfoModalOpen(false);
    navigate("/account");
  };

  const handleRentOut = () => {
    if (!isAuthenticated) {
      setIsInfoModalOpen(true);
      return;
    }
    
    if (!user?.stripeOnboardingComplete) {
      setIsInfoModalOpen(true);
      return;
    }

    navigate("/drone-service");
  };

  return (
    <div>
      <h2 className="text-[22px] font-ubuntu font-medium text-white mb-2">
        Monetize your drone by renting it out
      </h2>
      <p className="text-sm text-white font-ubuntu mb-4">
        Not only can renting out your drone be a lucrative side hustle, but it
        can also help offset the cost of owning a drone.
        <br />
        Plus, you'll have the satisfaction of knowing that your drone is being
        put to good use and helping others achieve their goals.
      </p>
      <Button 
        buttonType="rent" 
        className="font-ubuntu font-bold text-lg mt-4"
        onClick={handleRentOut}
      >
        Rent Out
      </Button>

      <InformationModal
        isOpen={isInfoModalOpen}
        onClose={() => setIsInfoModalOpen(false)}
        message={!isAuthenticated 
          ? "You need to be logged in to post a service. Please log in or sign up to continue."
          : "You need to complete your Stripe account setup before posting a service. Please set up your payment information to continue."}
        title={!isAuthenticated ? "Login Required" : "Stripe Account Required"}
        secondaryButton={isAuthenticated && !user?.stripeOnboardingComplete ? {
          label: "Go to Account Settings",
          onClick: handleStripeSetup
        } : undefined}
      />
    </div>
  );
};

export default TextSection;
